<template>
  <div class="content">
    <div class="container-fluid">
      <!-- <autocomplete :search="search" placeholder="Rechercher une commande" aria-label="Choisir une commande" :get-result-value="getResultValue"></autocomplete> -->
      <div class="row">
        <div class="col-12">
          <card
            class="strpied-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="uk-margin marquee">
                  <marquee direction="right">En cours . . . </marquee>
              </div>
              <div class="uk-flex uk-flex-between uk-align-center">
                <h4 class="card-title" style="font-weight: bold">
                  Gestion des colis
                </h4>
              </div>
            </template>
            <div class="row ml-2 mb-2">
                <div class="col-md-6 card box-shadow h-md-250">
                    <div class="card flex-md-row mb-4">
                        <div class="card-body d-flex justify-content-between align-items-start">
                            <strong class="d-inline-block mb-2 d-flex justify-content-between align-items-start text-primary">
                                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"></path>
                                </svg>RESTAURANT NOSTALGIE
                            </strong>
                            <div class="box phone text-success">
                                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                                </svg>0709080607
                            </div>
                            <div class="box dest text-info">
                            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                            </svg>MARCORY
                        </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-start">
                        <span>
                            Date de livraison:
                            <strong>18 - 05 - 2022</strong>
                        </span>
                        <span>
                            TOTAL: <strong>10000</strong> FCFA
                        </span>
                    </div>
                    <table class="uk-table uk-table-striped align-items-center">
                        <thead>
                            <tr>
                                <th>N°</th>
                                <th>Nature de colis</th>
                                <th>Nom du client</th>
                                <th>Contact du client</th>
                                <th>Montant du Colis</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{item+1}}</td>
                                <td>Nature de coli</td>
                                <td>{Montant}</td>
                                <td>Montantnt_phone</td>
                                <td>is.created_at</td>
                                <td>
                                    <span class="badge badge-success">Livré</span>
                                </td>
                            </tr> 
                            <tr>
                                <td>{{item+1}}</td>
                                <td>Nature de coli</td>
                                <td>{Montant}</td>
                                <td>Montantnt_phone</td>
                                <td>is.created_at</td>
                                <td>
                                    <span class="badge badge-danger">Retour</span>
                                </td>
                            </tr> 
                            <tr>
                                <td>{{item+1}}</td>
                                <td>Nature de coli</td>
                                <td>{Montant}</td>
                                <td>Montantnt_phone</td>
                                <td>is.created_at</td>
                                <td>
                                    <span class="badge badge-success">Livré</span>
                                </td>
                            </tr> 
                        </tbody>
                    </table>
                </div>
                <div class="col-md-6 card box-shadow h-md-250">
                    <div class="card flex-md-row mb-4">
                        <div class="card-body d-flex justify-content-between align-items-start">
                            <strong class="d-inline-block mb-2 d-flex justify-content-between align-items-start text-primary">
                                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"></path>
                                </svg>RESTAURANT NOSTALGIE
                            </strong>
                            <div class="box phone text-success">
                                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                                </svg>0709080607
                            </div>
                            <div class="box dest text-info">
                            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                            </svg>MARCORY
                        </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-start">
                        <span>
                            Date de livraison:
                            <strong>18 - 05 - 2022</strong>
                        </span>
                        <span>
                            TOTAL: <strong>10000</strong> FCFA
                        </span>
                    </div>
                    <table class="uk-table uk-table-striped align-items-center">
                        <thead>
                            <tr>
                                <th>N°</th>
                                <th>Nature de colis</th>
                                <th>Nom du client</th>
                                <th>Contact du client</th>
                                <th>Montant du Colis</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{item+1}}</td>
                                <td>Nature de coli</td>
                                <td>{Montant}</td>
                                <td>Montantnt_phone</td>
                                <td>is.created_at</td>
                                <td>
                                    <span class="badge badge-success">Livré</span>
                                </td>
                            </tr> 
                            <tr>
                                <td>{{item+1}}</td>
                                <td>Nature de coli</td>
                                <td>{Montant}</td>
                                <td>Montantnt_phone</td>
                                <td>is.created_at</td>
                                <td>
                                    <span class="badge badge-danger">Retour</span>
                                </td>
                            </tr> 
                            <tr>
                                <td>{{item+1}}</td>
                                <td>Nature de coli</td>
                                <td>{Montant}</td>
                                <td>Montantnt_phone</td>
                                <td>is.created_at</td>
                                <td>
                                    <span class="badge badge-success">Livré</span>
                                </td>
                            </tr> 
                        </tbody>
                    </table>
                </div>
                
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db, dbstore } from "../../main";
import Swal from "sweetalert2";
// import Jwpagination from "jwpagination";

export default {
  name: "Livraisons",
  data() {
    return {
      date_created: "",
      Colis: [],
      count: [],
      livreurName: [],
      livreurs: [],
      Livreur: {},
      access: 0,
    };
  },

  methods: {
    validDate() {
      let dbRef = db.ref("Colis Requetes")
      dbRef.get()
      .then((childSnapshot) => {
        const childData = childSnapshot.val();
        this.Colis = childData;
      })
      .catch((error) => {
        console.log(error);
      });
      db.ref("Colis Requetes")
      .orderByChild("created_at")
      .startAt(this.date_created)
      .once("value")
      .then((dataSnapshot) => {
        dataSnapshot.forEach((childSnapshot) => {
          this.colisDuJour.push(childSnapshot.val())
        });
          this.show = true;
      });
    },
    search(input) {
      if (input.length < 1) {
        return [];
      }
      return this.livreurs.filter((uneboutique) => {
        return uneboutique.name.toLowerCase().startsWith(input.toLowerCase());
      });
    },
    currentDateTime() {
      const current = new Date();
      const date =
        current.getDate() +
        " - 0" +
        (current.getMonth() + 1) +
        " - " +
        current.getFullYear();
      const dateTime = date;
      return dateTime;
    },
    formatDate(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString("fr", options);
    },
    formatHeure(date) {
      const options = { hour: "numeric", minute: "numeric", second: "numeric" };
      return new Date(date).toLocaleString("fr", options);
    },
    searchLivreur(id) {
      db.ref("users")
        .child(id)
        .on("value", (theSnapshot) => {
          const livreurData = theSnapshot.val();
          this.livreurName = livreurData.name;
        });
      return this.livreurName;
    },
    saveColis(key) {
        if (this.access == 5 || this.access == 4 || this.access == 3) {
          Swal.fire({
            title: " La livraison a t'elle été effectuée?",
            text: "La livraison va être enregistrée pour toujours!",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#34B76E",
            cancelButtonColor: "#BEBEBE",
            cancelButtonText: "Non",
            confirmButtonText: "Oui",
          }).then(async (result) => {
            if (result.isConfirmed) {
              return db.ref("Colis Requetes").child(key).once("value").then(function (snapshot) {
                  snapshot.forEach(function (childSnapshot) {
                    let childData = childSnapshot.val();
                    dbstore.collection("livraisons_terminees").add({
                      client_name: childData.client_name,
                      client_phone: childData.client_phone,
                      colis_type: childData.colis_type,
                      contact_recup: childData.contact_recup,
                      created_at: childData.created_at,
                      depart_address: childData.depart_address,
                      dest_address: childData.depart_address,
                      dest_contact: childData.dest_contact,
                      id_colis: childData.id_colis,
                      livreur_id: childData.livreur_id,
                      montant: Number(childData.montant),
                      valeur: Number(childData.valeur),
                      nature: childData.nature,
                      categorie: childData.categorie,
                      payment_method: childData.payment_method,
                      boutique_id: childData.boutique_id,
                      statut: "livré",
                    });
                    db.ref("Colis Requetes").child(key).remove(),
                      Swal.fire(
                        "Livraison enrégistré!",
                        "La livraison a été enrégistrée avec succès.",
                        "success"
                      );
                  });
                });
            }
          });
        } else {
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });
          Toast.fire({
            icon: "error",
            title: '<span style="color:#B74334">Action non autorisée!</span>',
          });
      }
    },
    removeColis(key) {
      if (this.access == 5) {
        /* Swal.fire({
        title: 'Êtes vous sûr?',
        text: "Voulez vous vraiment supprimer cette livraisons!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#34B76E',
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Supprimer'
      }).then((result) => {
        if (result.isConfirmed) {
          db.ref("Colis Requetes").child(key).remove();
          Swal.fire(
            'Supprimer!',
            'La livraison a été supprimé avec succès.',
            'success'
          )
        }
      })
      }else{
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });
        Toast.fire({
          icon: "error",
          title: '<span style="color:#B74334">Action non autorisée!</span>',
        }); */
      }
      db.ref("Colis Requetes").child(key).remove();
    },
  },

  created() {
    this.access = this.$store.getters.user.data.role;
    const dfRef = db.ref("Colis Requetes")
      // .orderByChild("created_at")
      dfRef.on("value", (dataSnapshot) => {
        const itemsArray = [];
        dataSnapshot.forEach((childSnapshot) => {
          const childData = childSnapshot.val();
          const childDataKey = childSnapshot.key;
          this.Colis = childData;
          itemsArray.push({
            id: childDataKey,
            client_name: childData.client_name,
            client_phone: childData.client_phone,
            colis_type: childData.colis_type,
            depart_address: childData.depart_address,
            dest_address: childData.dest_address,
            dest_contact: childData.dest_contact,
            id_colis: childData.id_colis,
            valeur: childData.valeur,
            montant: childData.montant,
            nature: childData.nature,
            created_at: childData.created_at,
            statut: childData.statut,
            livreur_id: childData.livreur_id,
            payment_method: childData.payment_method,
            categorie: childData.categorie,
          });
        });
        this.Colis = itemsArray.reverse();
      });

    // let dbRef = db.ref("Colis Requetes").child(this.$route.params.id);
    // dbRef
    // .get()
    // .then((childSnapshot) => {
    //   const childData = childSnapshot.val();
    //   this.Colis = childData;
    //   let dbRef = db
    //     .ref("users")
    //     .child(this.Colis.livreur_id)
    //     .get()
    //     .then((childSnapshot) => {
    //       const livreurData = childSnapshot.val();
    //       this.Livreur = livreurData;
    //     });
    // })
    // .catch((error) => {
    //   console.log(error);
    // });

    db.ref("users")
      .orderByChild("role")
      .equalTo("1")
      .once("value")
      .then((dataSnapshot) => {
        const itemsArray = [];
        dataSnapshot.forEach((childSnapshot) => {
          const childData = childSnapshot.val();
          itemsArray.push({
            id: childData.id,
            role: childData.role,
            statusLivreur: childData.statusLivreur,
            name: childData.name,
            number: childData.number,
            email: childData.email,
          });
        });
        this.livreurs = itemsArray;
      });

    // var dbRef = db.ref('boutiques').child(this.$route.params.uuid);
    // dbRef
    // .get()
    // .then((childSnapshot) => {
    //     const onData = childSnapshot.val();
    //     this.boutique = onData;
    // })
    // .catch(() => {
    //     console.log(dbRef);
    // });
  },
};
</script>

<style>
.tilte-tab {
  color: #000000 !important;
  font-weight: bold !important;
  font-size: 0.9em !important;
  font-family: "Poppins", sans-serif !important;
}
.livraison {
  font-weight: bold !important;
}
.btn-primary {
  margin-right: 12px;
}
.dateToday {
  padding: 10px;
  border-radius: 20px;
  color: #ffffff !important;
}
.uk-form-width-small {
  background-color: #5dd381 !important;
  color: #ffffff !important;
  font-weight: bold !important;
  font-size: 0.9em !important;
  outline: none;
  border-radius: 10px;
  border: none;
}
.uk-label {
  font-size: 0.9em !important;
  font-weight: bold !important;
}
.uk-label:hover {
  background-color: #1f5cdf !important;
}
.uk-label:active {
  background-color: #0c307e !important;
}
.card-body svg {
    width: 20px;
    /* height: 30px; */
    padding: 0px !important;
}
.col .details {
    font-family: monospace !important;
    font-size: 0.2em !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.col .details .box {
    display: flex;
    justify-content: center !important;
    text-align: center !important;
    align-items: center;
}

.marquee {
  font-size: 1.5rem;
  font-weight: bold;
  color: #fff;
  background: linear-gradient(to right, #13D0D3, #10A4A6);
  padding: 0.2rem;
  border-radius: 0.2rem;
  animation: marquee 15s linear infinite;
}
</style>

